<template>
    <div>
        <div class="simple-row">
            <div class="right">
                <button @click="exportPdf" class="swb-btn-small swb-btn">导出pdf</button>
            </div>
        </div>
        <swb-shop-device-trans-voucher-devc-for-pdf v-if="!lowCostFlag" :voucherId="voucherId" ref="swb_shop_device_trans_voucher_for_pdf"></swb-shop-device-trans-voucher-devc-for-pdf>
        <swb-stuff-trans-voucher-devc-for-pdf v-else :voucherId="voucherId" ref="swb_stuff_trans_voucher_for_pdf"></swb-stuff-trans-voucher-devc-for-pdf>
    </div>

</template>
<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import SwbShopDeviceTransVoucherForPdf from './ShopDeviceTransVoucherForPdf';

Vue.regist(SwbShopDeviceTransVoucherForPdf);
import SwbStuffTransVoucherForPdf from './StuffTransVoucherForPdf';

Vue.regist(SwbStuffTransVoucherForPdf);
//
import { showHtmlToPdfDlg } from '../ctrl/dialog'

export default {
    name: 'swb-shop-device-trans-voucher-devc-pdf',
    desc: '调拨单导出',
    props: {
        voucherId: {
            type: Number,
            deafult: null,
        },
        lowCostFlag: {
            type: Boolean,
            deafult: false
        }
    },
    data: function () {
        return {}

    },
    created: function () {
    },
    methods: {
        exportPdf: function () {
            let self = this;
            let result = '';
            if(!Utils.isTrue(self.lowCostFlag)) {
                result = self.$refs.swb_shop_device_trans_voucher_for_pdf.getHtml() || '';
            } else {
                result = self.$refs.swb_stuff_trans_voucher_for_pdf.getHtml() || '';
            }
            showHtmlToPdfDlg('调拨单-业务单据', result, null);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/tranVoucherDevc/ShopDeviceTransVoucherPdf.vue